'use strict';

import config from 'config';
import React, { Component } from 'react';
import Avatar from 'components/Avatar';
import zChat from 'vendor/web-sdk';

const { LABELS } = config;

class StatusContainer extends Component {


  constructor(props) {
    super(props);
    this.getStatusText = this.getStatusText.bind(this);
    this.updateAfterMemberJoined = this.updateAfterMemberJoined.bind(this);
    this.updateAfterMemberLeave = this.updateAfterMemberLeave.bind(this);
    this.updateAfterRating = this.updateAfterRating.bind(this);
    this.state = {
      currentAgent: null,
      hasRating: false,
      rate: false
    };
  }

  componentDidMount(){
    zChat.on('agent_update', this.updateAfterMemberJoined);
    zChat.on('chat', this.updateAfterRating);
    zChat.on('chat', this.updateAfterMemberLeave);

  }
 
  updateAfterMemberJoined( data ) {
    this.setState( {
      currentAgent: data
    } );
  }

  updateAfterMemberLeave( data ) {
    if ( 'chat.memberleave' !== data.type ) {
      return;
    }

    this.setState( {
      currentAgent: null
    } );
  }

  updateAfterRating( data ) {
    if ( 'chat.rating' !== data.type ) {
      return;
    }

    this.setState( {
      hasRating: !! data.new_rating,
      rate: data.new_rating
    } );
  }

  renderIcon() {
    const isString = typeof(this.props.icon) === 'string';
    return (
      <div className="image-icon">
        {!isString && this.props.icon}
      </div>
    );
  }

  showUserAgent(agent) {
    if ( ! agent ) {
      return;
    }
    return (
      <div className="current-agent">
          <Avatar entity={agent} />
          <div className="agent-name-and-role">
            <div className="agent-name">{agent.display_name}</div>
            <div className="agent-role">{agent.title}</div>
          </div>
        </div>
    );
  }


  getStatusText(status, agent) {
    if ( agent ) {
      return;
    }
    switch (status) {
      case 'online': return LABELS.chat_status_online || 'Pre-sale Chat';
      case 'offline': return LABELS.chat_status_offline || 'Leave us a message';
      case 'away': return LABELS.chat_status_away || 'We\'re away!';
      default: return LABELS.chat_status_connecting || 'Connecting...';
    }
  }

  render() {
    const { currentAgent } = this.state;

    return (
      <div className="status-container">
        <div className="agent-and-rating">
          {this.showUserAgent(currentAgent)}
        </div>
        {this.getStatusText(this.props.accountStatus, currentAgent)}
        <div className="minimize-button" onClick={this.props.minimizeOnClick}>
          <div className="minimize-button-bar" />
        </div>
      </div>
    );
  }
}

StatusContainer.displayName = 'StatusContainer';
StatusContainer.propTypes = {
  accountStatus: React.PropTypes.string,
  minimizeOnClick: React.PropTypes.func
}
export default StatusContainer;



// WEBPACK FOOTER //
// ./src/components/StatusContainer.js